module.exports = __webpack_public_path__ + "static/img/footer.849e0d9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/footer.png
// module id = 86
// module chunks = 1